import { LangKey } from "@vixi/localization";

export enum COURSE_STATUS {
  PUBLISHED,
  WAITING_PUBLISH,
  WAITING_UNPUBLISH,
  DRAFT,
}

export const COURSE_STATUS_LABELS: Record<COURSE_STATUS, LangKey> = {
  [COURSE_STATUS.PUBLISHED]: "CourseState.Published",
  [COURSE_STATUS.WAITING_PUBLISH]: "CourseState.InReview",
  [COURSE_STATUS.WAITING_UNPUBLISH]: "CourseState.Unpublishing",
  [COURSE_STATUS.DRAFT]: "CourseState.Draft",
};

export default COURSE_STATUS;
